import { render } from "./column-menu.vue?vue&type=template&id=707bb4a4"
import script from "./column-menu.vue?vue&type=script&lang=js"
export * from "./column-menu.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\avue\\avue3.0\\avue\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+compiler-sfc@3.5.12_vue@3.5.27_typescript@5.9.3__webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"packages/element-plus/crud/column/column-menu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "707bb4a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('707bb4a4', __exports__)) {
    console.log('reload')
    api.reload('707bb4a4', __exports__)
  }
  
  module.hot.accept("./column-menu.vue?vue&type=template&id=707bb4a4", () => {
    console.log('re-render')
    api.rerender('707bb4a4', render)
  })

}


export default __exports__